/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Revenue_MonthInputs */

const vi_dashboard_revenue_month = /** @type {(inputs: Dashboard_Revenue_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu tháng`)
};

/**

* @param {Dashboard_Revenue_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_revenue_month = /** @type {((inputs?: Dashboard_Revenue_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Revenue_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_revenue_month(inputs)
});